import React from "react";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Column,
  ColumnType,
  SortDirection,
  ColumnOptions,
  DataTable,
  BasicCell,
  TimeDataCell,
} from "@transfr-inc/dashboard-components/data-table";

import { Rating } from "@transfr-inc/dashboard-components";
import { formatDateDigits } from "@transfr-inc/dashboard-components/utils";

import "./trainee.ce-simulations.table.scss";
import { ColumnHeaderInformationTooltip } from "@components/custom/content/column-header-information-tooltip";

import { getLearnerTerm } from "@transfr-inc/dashboard-components/constants";

export function TraineeCeSimulationsTable({ sims, responsiveStyles }) {
  const columns = [
    new Column(
      "name",
      "Name",
      ColumnType.BASIC,
      new ColumnOptions({ sortingEnabled: false, overflowEnabled: true })
    ),
    new Column(
      "clusterName",
      "Cluster",
      ColumnType.BASIC,
      new ColumnOptions({ sortingEnabled: true, overflowEnabled: true })
    ),
    new Column(
      "occupationName",
      "Career",
      ColumnType.BASIC,
      new ColumnOptions({ sortingEnabled: true, overflowEnabled: true })
    ),
    new Column(
      "timestamp",
      (
        <ColumnHeaderInformationTooltip
          headerTitle={"Date"}
          tooltipText={"Last attempted date"}
        ></ColumnHeaderInformationTooltip>
      ),
      ColumnType.CUSTOM,
      new ColumnOptions({
        sortingEnabled: true,
        customFunction: (value) => {
          const formattedDate = value ? formatDateDigits(value) : undefined;
          return <BasicCell value={formattedDate}></BasicCell>;
        },
      })
    ),
    new Column(
      "timeSpent",
      "Total Time",
      ColumnType.CUSTOM,
      new ColumnOptions({ sortingEnabled: true, customFunction: TimeDataCell })
    ),
    new Column(
      "attempts",
      "Attempts",
      ColumnType.COUNT,
      new ColumnOptions({ sortingEnabled: true })
    ),
    new Column(
      "rating",
      (
        <ColumnHeaderInformationTooltip
          headerTitle={"Rating"}
          tooltipText={"Last attempted rating (1-5)"}
        ></ColumnHeaderInformationTooltip>
      ),
      ColumnType.CUSTOM,
      new ColumnOptions({
        sortingEnabled: true,
        customFunction: (value) => <Rating value={value ?? 0} />,
      })
    ),
    new Column(
      "completed",
      (
        <ColumnHeaderInformationTooltip
          headerTitle={"Complete"}
          tooltipText={`Careers where ${getLearnerTerm({
            lowercase: true,
            plural: true,
          })} have reached the end. May or may not include a rating.`}
          position={"top-end"}
        ></ColumnHeaderInformationTooltip>
      ),
      ColumnType.CUSTOM,
      new ColumnOptions({
        sortingEnabled: true,
        customFunction: (value, row) => {
          const icon =
            value || row.rating > 0
              ? ["fa-solid", "fa-circle-check"]
              : ["fa-regular", "fa-circle"];
          return (
            <div className="completed-cell">
              <FontAwesomeIcon icon={icon}></FontAwesomeIcon>
            </div>
          );
        },
      })
    ),
  ];

  return (
    <DataTable
      className={clsx("trainee-ce-simulations-table", responsiveStyles)}
      columns={columns}
      defaultSortDirection={SortDirection.DESCENDING}
      defaultSortPropName={"latestTimeStamp"}
      data={sims}
      keyFields={["learningExperienceId"]}
      responsiveStyles={responsiveStyles}
    ></DataTable>
  );
}
